import React from "react";
import { sectorTopics } from "../data/content";
const INSTITUTION = "https://cdn.magicpatterns.com/patterns/generated-images/8218a846-c326-4a12-8fb7-55c62c3513a9.jpg";
export function Sector() {
  return <section id="secteur" className="bg-ink py-24 text-white lg:py-32" data-id="element-140" data-mp="2fyy5mf9zntye">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-141" data-mp="2byo2dadkzhn8">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-142" data-mp="2bz7jioveq207">
          <div className="lg:col-span-5" data-id="element-143" data-mp="1o81vvnj865fc">
            <p className="text-[15px] font-medium text-white/60" data-id="element-144" data-mp="1oaxrv6biik15">Secteur des jeux</p>
            <h2 className="mt-4 font-display text-4xl font-semibold leading-[1.1] tracking-tight sm:text-5xl" data-id="element-145" data-mp="1jbbgz3j5pfvi">
              Un marché régulé, des enjeux qui se jouent au Parlement.
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-white/70" data-id="element-146" data-mp="1s8vjsgwo3k88">
              Depuis l'ouverture à la concurrence en 2010, le jeu en ligne évolue au rythme des lois de
              finances, des délibérations du régulateur et des débats européens. Connaître ces
              mécanismes est un avantage décisif.
            </p>
            <div className="mt-10 overflow-hidden rounded-2xl" data-id="element-147" data-mp="2uqsrw0h81jjk">
              <img src={INSTITUTION} alt="Façade d'un bâtiment institutionnel parisien" className="aspect-[4/3] w-full object-cover" data-id="element-148" data-mp="2uozlmmait1c3" />
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-149" data-mp="2718ahm0puuce">
            <ul className="grid sm:grid-cols-2" data-id="element-150" data-mp="2729kro9wrct2">
              {sectorTopics.map(t => <li key={t.title} className="border-t border-white/15 py-8 sm:pr-10 sm:[&:nth-child(even)]:pl-10 sm:[&:nth-child(even)]:pr-0 sm:[&:nth-child(even)]:border-l" data-id="element-151" data-mp="2c1cs5fdd1v47">
                  <h3 className="font-display text-xl font-semibold" data-id="element-152" data-mp="2lpuq7ou99o45">{t.title}</h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-white/65" data-id="element-153" data-mp="1oaqk3o3cwau7">{t.text}</p>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}